import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import {
  Box,
  List,
  Divider,
  ListItem,
  IconButton,
  ListItemText,
  ListItemSecondaryAction,
} from '@material-ui/core';

import i18n from 'i18n-js';
import Can from 'components/Can';
import { Card } from 'components/UI';
import Loading from 'components/Loading';
import EditIcon from '@material-ui/icons/Edit';
import { ChangeVehicleGroupsServicesModal } from 'components/Modals';
import { useStyles, listTextStyles, listItemsTextStyles } from './styles';

const VehicleGroupServicesWidget = ({ id }) => {
  const classes = useStyles();
  const listClasses = listTextStyles();
  const listItemTextClasses = listItemsTextStyles();
  const {
    current,
    loading: VGisLoading,
    onboarding: { steps },
  } = useSelector((state) => state.vehiclesGroups);
  const [open, setOpen] = useState(false);

  const handleLocationsModalOpen = () => {
    setOpen((prevState) => !prevState);
  };

  const menuItems = [
    {
      title: i18n.t('vehicle_groups.edit_services'),
      can: { name: 'vehicle_group', action: 'update' },
      onClick: handleLocationsModalOpen,
    },
  ];

  return (
    <Card
      menuItems={menuItems}
      headerActionType="vertical"
      data-cy="vg-services-widget-card"
      title={i18n.t('vehicle_groups.services')}
    >
      {VGisLoading ? (
        <Box
          className={classes.loadingContainer}
          justifyContent="center"
          alignItems="center"
          display="flex"
        >
          <Loading />
        </Box>
      ) : (
        <Box className={classes.cardContentPadding}>
          {current?.shared_services?.length ? (
            <List className={classes.list}>
              {current?.shared_services?.map((service, index) => (
                <>
                  <ListItem key={`service-${service}`}>
                    <ListItemText classes={listClasses} primary={`${service}`} />
                    <ListItemSecondaryAction classes={listItemTextClasses}>
                      <Can I="update" a="vehicle_group">
                        <Box fontSize={13}>
                          <IconButton onClick={handleLocationsModalOpen}>
                            <EditIcon
                              style={{
                                color: '#8E8E93',
                                fontSize: 16,
                                cursor: 'pointer',
                              }}
                            />
                          </IconButton>
                        </Box>
                      </Can>
                    </ListItemSecondaryAction>
                  </ListItem>
                  {
                    //TODO: Replace divider with css class for li on this and
                    // Location widgets
                    // ... Material makes things complicated for pseudo elements
                    index < current?.shared_services?.length - 1 ? (
                      <Divider className={classes.divider} />
                    ) : (
                      <></>
                    )
                  }
                </>
              ))}
            </List>
          ) : (
            i18n.t('common.no_records_to_display')
          )}
        </Box>
      )}
      {open && (
        <ChangeVehicleGroupsServicesModal
          open={open}
          steps={steps}
          currentGroup={current}
          handleClick={handleLocationsModalOpen}
        />
      )}
    </Card>
  );
};

export { VehicleGroupServicesWidget };
